import React from 'react';
import DocumentTitle from 'react-document-title';
import './signup3.css'
export default class SignUpPage3 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            vegActive:false,
            fruitActive:false,
            animalActive:false,
            grainActive:false
        }
        this.handValueChange=this.handValueChange.bind(this)
    }
    handValueChange(component){
        let self=this
        this.setState({
            [component]:!this.state[component]
        },function () {
            let items="";
            items=items+self.state.vegActive?"Veg,":items
            items=items+self.state.fruitActive?"Fruit,":items
            items=items+self.state.animalActive?"Animal,":items
            items=items+self.state.grainActive?"Grain,":items
            self.props.changer().handleChangeData("buying",items);

        })
    }

    render() {
        return (
            <DocumentTitle title="Khula - Billing">
                <div className="signupcontainer">

                    <div className="imagecontainer">

                        <img src="https://client.khula.co.za/images/delivery.jpg" alt="" width="100%" height="auto"/>

                    </div>

                    <div className="signupcontent">

                        <h2>What are you buying?</h2>



                        <div className="produceoptions">

                            <div className="veg">
                                <img src="https://client.khula.co.za/images/vegetables.png" alt="" width="90%" style={this.state.vegActive?{opacity:1}:{opacity:0.3}} onClick={()=>{this.handValueChange("vegActive")}}/>
                            </div>
                            <div className="fruit">
                                <img src="https://client.khula.co.za/images/orange.png" alt="" width="90%" style={this.state.fruitActive?{opacity:1}:{opacity:0.3}}  onClick={()=>{this.handValueChange("fruitActive")}} />
                            </div>
                            <div className="poultry">
                                <img src="https://client.khula.co.za/images/hen.png" alt="" width="90%" style={this.state.animalActive?{opacity:1}:{opacity:0.3}} onClick={()=>{this.handValueChange("animalActive")}}/>
                            </div>
                            <div className="maize">
                                <img src="https://client.khula.co.za/images/cereal.png" alt="" width="90%" style={this.state.grainActive?{opacity:1}:{opacity:0.3}} onClick={()=>{this.handValueChange("grainActive")}}/>
                            </div>
                        </div>

                    </div>
                </div>
            </DocumentTitle>

        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/SignUpPages/Page3.js